module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.22787/images/shopify-authorization-connect.svg"